import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "form", "actions", "nameInput"]

  edit() {
    this.displayTarget.classList.add("hidden")
    this.actionsTarget.classList.add("hidden")
    this.formTarget.classList.remove("hidden")
    this.nameInputTarget.focus()
  }

  cancel() {
    this.displayTarget.classList.remove("hidden")
    this.actionsTarget.classList.remove("hidden")
    this.formTarget.classList.add("hidden")
  }
}
